<template>
  <div>
    <el-breadcrumb style="float: right" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }"> {{$t('route.home')}}</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ name: 'refereeList' }">{{$t('entities.referee.plural')}}</el-breadcrumb-item>
      <el-breadcrumb-item>{{$t('table.history')}}</el-breadcrumb-item>    </el-breadcrumb>

    <h2 class="page-title">{{$t('entities.referee.singular')}} history</h2>

    <div v-loading="loading">
      <el-table
        :data="list"
        empty-text="There is no history yet"
        style="width: 100%"
        border
      >
        <el-table-column
          prop="modified"
          label="Updated at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.modified | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Updated by"
          prop="modifiedBy.email"
        ></el-table-column>

        <el-table-column
          prop="name"
          label="Name"
        ></el-table-column>

        <el-table-column
          prop="lastName"
          label="LastName"
        ></el-table-column>

        <el-table-column
          prop="email"
          label="Email"
        ></el-table-column>

        <el-table-column
          prop="phone"
          label="Phone"
        ></el-table-column>

        <el-table-column
          prop="created"
          label="Created at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.created | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Created by"
          prop="createdBy.email"
        ></el-table-column>

        <el-table-column
          prop="deleted"
          label="Deleted at"
          width="180"
        >
          <template slot-scope="scope">
            {{ scope.row.deleted | formatDatetime }}
          </template>
        </el-table-column>

        <el-table-column
          label="Deleted by"
          prop="deletedBy.email"
        ></el-table-column>
      </el-table>

      <el-button
        v-if="!last"
        @click="fetch()"
        type="infor"
        class="mt-3 w-100"
        icon="el-icon-fa-plus"
      >
        Load more...
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'app-referee-history-full',

  computed: {
    ...mapGetters({
      loading: 'entities/referee/historyFull/loading',
      list: 'entities/referee/historyFull/list',
      last: 'entities/referee/historyFull/last',
    }),
  },

  created() {
    this.$store.dispatch(
      'entities/referee/historyFull/setup'
    );
  },

  beforeRouteLeave(to, from, next) {
    this.$store.dispatch(
      'entities/referee/historyFull/clear',
    );
    next();
  },

  methods: {
    ...mapActions({
      fetch: 'entities/referee/historyFull/fetch',
    }),
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/entities/referee/referee-history/referee-history-full/referee-history-full.vue?20d6f9d9